import React from 'react';
import PropTypes from 'prop-types';
import { AnimatedGradientBorder } from 'components';
import * as Ui from './AiBadge.styles';

const defaultColors = ['#f82fc6', '#5a4ff9', '#ff923e'];

const AiBadge = ({
  text = 'AI',
  colors = defaultColors,
  borderRadius = 4,
  borderWidth = 1.5,
  blur = 5,
  speed = 2,
  backgroundColor = '#000000',
  textColor = '#ffffff',
  className,
}) => (
  <Ui.Container className={className}>
    <AnimatedGradientBorder
      colors={colors}
      borderRadius={borderRadius}
      borderWidth={borderWidth}
      blur={blur}
      speed={speed}
      backgroundColor={backgroundColor}
    >
      <Ui.Label $textColor={textColor}>{text}</Ui.Label>
    </AnimatedGradientBorder>
  </Ui.Container>
);

AiBadge.propTypes = {
  text: PropTypes.string,
  colors: PropTypes.arrayOf(PropTypes.string),
  borderRadius: PropTypes.number,
  borderWidth: PropTypes.number,
  blur: PropTypes.number,
  speed: PropTypes.number,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  className: PropTypes.string,
};

export default AiBadge;
